module.exports = __webpack_public_path__ + "static/img/cybercrime.9ba79dc7.png";